<template>
	<div class="excerpt">
		<p key="text" v-html="text"></p>
		<span
			key="btn"
			v-if="item.length > 150"
			class="show-btn"
			@click="showAll = !showAll"
		>
			<svg
				aria-hidden="true"
				focusable="false"
				data-prefix="far"
				data-icon="plus-square"
				class="svg-inline--fa fa-plus-square fa-w-14"
				role="img"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 448 512"
				v-if="!showAll"
			>
				<path
					fill="currentColor"
					d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
				></path>
			</svg>
			<svg v-if="showAll" aria-hidden="true" focusable="false" data-prefix="far" data-icon="minus-square" class="svg-inline--fa fa-minus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg>
			{{ btn_label }}</span
		>
	</div>
</template> 

<script>
export default {
	props: {
		item: { type: String, required: true },
		view_more: { type: String, required: true },
		view_less: { type: String, required: true }
	},
	data() {
		return {
			showAll: true
		};
	},
	computed: {
		text() {
			return this.showAll ? this.item : this.truncate(this.item);
		},
		btn_label() {
			return this.showAll ? this.view_less : this.view_more;
		}
	},
	methods: {
		truncate: function(value) {
			let length = 150;

			if (value.length <= length) {
				return value;
			} else {
				return value.substring(0, length) + "...";
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.excerpt {
	margin: 20px 0;

	> * {
		transition: all 0.5s;
	}

	p {
		font-size: 14px;
		line-height: 18px;
	}

	span {
		display: inline-block;
		cursor: pointer;
		margin-top: 30px;
		font-size: 12px;

		@include res(tab-p) {
			margin: 20px 0 10px;
		}

		svg {
			width: 11px;
			height: 11px;
		}
	}
}
</style>
